import React from 'react';
import ReactDOM from 'react-dom';

import './sso-app/index.css';
import App from './sso-app';

ReactDOM.render(<App />, document.getElementById('root'));
